import { toast, useToggleState } from '@medusajs/ui';

import { useMonthlySettlementInfo } from '@lib/hooks/use-monthly-settlement-info';

import { SettlementNotificationButton } from './settlement-notification-button';
import { SettlementNotificationModal } from './settlement-notification-modal';

/**
 * 月結繳款通知的容器元件。
 * 管理繳款資訊狀態並分發到 Button 和 Modal 子元件。
 */
export const MonthlySettlementContainer = () => {
  const { data: settlementInfo, isLoading, isError } = useMonthlySettlementInfo();
  const {
    state: isModalOpen,
    open: openModal,
    close: closeModal,
  } = useToggleState(false);

  const hasExistingPayment =
    settlementInfo?.pendingRequests.hasCurrentMonthPeriod ?? false;

  const handleOpenModal = () => {
    if (isError || !settlementInfo) {
      toast.error('無法取得帳單資訊，請稍後再試');
      return;
    }
    openModal();
  };

  return (
    <>
      <SettlementNotificationButton
        hasExistingPayment={hasExistingPayment}
        isLoading={isLoading}
        onClick={handleOpenModal}
      />
      <SettlementNotificationModal
        isOpen={isModalOpen}
        onClose={closeModal}
        settlementInfo={settlementInfo}
      />
    </>
  );
};
